import React from 'react';
import { CtaButton } from './CtaButton';
import { HeartMark } from './decor/HeartMark';
export function SiteHeader() {
  return <header className="sticky top-0 z-40 border-b border-cream-line/80 bg-cream/90 backdrop-blur" data-id="element-316" data-mp="19uq6qv6f824m">
      <div className="mx-auto flex h-16 max-w-content items-center justify-between gap-3 px-5 sm:px-8" data-id="element-317" data-mp="1nmel754572or">
        <a href="#top" className="flex min-w-0 items-center gap-2 text-navy" aria-label="DAS GROSSE EVANGELISATIONS-PAKET" data-id="element-318" data-mp="1iod24k6pv3da">
          <HeartMark className="h-5 w-5 shrink-0 text-coral" data-id="element-319" data-mp="v027hyrm5zxg" />
          <span className="whitespace-nowrap font-display text-lg leading-none sm:text-xl" data-id="element-320" data-mp="qxysj05qkd7f">DAS GROSSE</span>
          <span className="hidden whitespace-nowrap text-xs font-bold uppercase tracking-[0.14em] text-gold-deep sm:inline" data-id="element-321" data-mp="14xztefm03kmw">Evangelisations-Paket</span>
        </a>
        <CtaButton size="md" data-id="element-322" data-mp="2gb28f68gc24y">Zugang sichern</CtaButton>
      </div>
    </header>;
}